import { createReducer } from "redux-act";
import { Record, Map, fromJS } from "immutable";

import * as actions from "./actions";

const State = Record({
  results: new Map(),
  params: new Map({
    default: new (Record({
      currentPage: 1,
      limit: 15,
      offset: 0,
      sortField: "created_at",
      sortDir: "desc"
    }))()
  })
});

const reducer = createReducer(
  {
    [actions.getAllAction.success]: (state, { data: { result }, view }) => {
      return state
        .setIn(["results", view, "meta"], fromJS(result.meta))
        .setIn(["results", view, "ids"], result.applications);
    },
    [actions.setSortAction]: (state, { sortField, sortDir, view }) => {
      return state
        .setIn(["params", view, "sortField"], sortField)
        .setIn(["params", view, "sortDir"], sortDir);
    },
    [actions.setPageAction]: (state, { page, view }) => {
      const limit = state.getIn(["params", view, "limit"]);
      return state
        .setIn(["params", view, "currentPage"], page)
        .setIn(["params", view, "offset"], (page - 1) * limit);
    }
  },
  new State()
);

export default reducer;



// WEBPACK FOOTER //
// ./src/applications/reducer.js